import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import StaticPageHeader from '../components/common/StaticPageHeader';
import CustomInput from '../components/common/CustomInput';
import { Helmet } from 'react-helmet-async';

const TrackYourOrder = () => {
    const [orderId, setOrderId] = useState('');
    const [email, setEmail] = useState('');

    const handleTrack = (e) => {
        e.preventDefault();
        // Tracking logic would go here
    };

    const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';

    return (
        <div className="static-page-wrapper bg-light min-vh-100 pb-5">
            <Helmet>
                <title>Track Your Order | Online Store</title>
                <meta name="description" content="Track your shipment and order delivery status in real time. Enter your Order ID and billing email to track." />
                {currentOrigin && <link rel="canonical" href={`${currentOrigin}/track`} />}
            </Helmet>
            <StaticPageHeader title="Track Your Order" />

            <section className="static-page-container mt-4 mb-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-10 col-lg-8 col-xl-6">
                            <div className="bg-white border shadow-sm p-4 p-md-5 mb-4" style={{ borderRadius: '12px' }}>
                                <div className="text-center mb-5">
                                    <h3 className="fw-bold text-dark mb-3" style={{ fontSize: '1.75rem' }}>Where's My Stuff?</h3>
                                    <p className="text-secondary" style={{ lineHeight: '1.7' }}>
                                        To track your order please enter your Order ID in the box below and press the "Track" button. This was given to you on your receipt and in the confirmation email you should have received.
                                    </p>
                                </div>

                                <form onSubmit={handleTrack}>
                                    <div className="form-group mb-4">
                                        <label className="form-label text-dark fw-medium">Order ID</label>
                                        <input 
                                            type="text" 
                                            className="form-control form-control-lg bg-light border-0 shadow-none py-3"
                                            style={{ borderRadius: '8px', fontSize: '1rem' }}
                                            value={orderId} 
                                            onChange={(e) => setOrderId(e.target.value)} 
                                            placeholder="e.g. KUM-2026..."
                                            required
                                        />
                                    </div>
                                    <div className="form-group mb-4">
                                        <label className="form-label text-dark fw-medium">Billing Email</label>
                                        <input 
                                            type="email" 
                                            className="form-control form-control-lg bg-light border-0 shadow-none py-3"
                                            style={{ borderRadius: '8px', fontSize: '1rem' }}
                                            value={email} 
                                            onChange={(e) => setEmail(e.target.value)} 
                                            placeholder="e.g. customer@example.com"
                                            required
                                        />
                                    </div>

                                    <div className="form-group mt-4 pt-2">
                                        <button type="submit" className="btn btn-dark w-100 py-3 fw-medium shadow-sm transition-hover" style={{ borderRadius: '8px' }}>
                                            Track Order <i className="fas fa-search ml-2"></i>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default TrackYourOrder;